import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./badge.html";
import { logger } from '~/modules/utilities/logger';
class Badge extends LightningElement {
  constructor(...args) {
    super(...args);
    this.badge = void 0;
  }
  get value() {
    try {
      return this.badge.i18nFn();
    } catch (error) {
      logger.warn(`Missing localized label for badge '${this.badge.i18nKey}'`);
      return '';
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Badge, {
  publicProps: {
    badge: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Badge, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;